var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Refresh_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0,
    d: "M6 6h16v16H6z"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#000",
    opacity: 0.5,
    rx: 14
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    clipPath: "url(#Refresh_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 14c0-.8-.16-1.57-.46-2.3-.31-.74-.74-1.38-1.3-1.95-.56-.56-1.21-.99-1.95-1.3-.73-.3-1.5-.45-2.29-.45-1.75 0-3.25.61-4.5 1.82L8 11.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8v3.33h3.33M8 14c0 .79.15 1.56.45 2.29.31.74.74 1.39 1.3 1.95s1.21.99 1.95 1.3c.73.3 1.5.46 2.3.46 1.74-.01 3.24-.62 4.49-1.83L20 16.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.66 16.66H20V20"
  }))));
};
export default SvgRefresh;